import { render } from "./AppEmptyList.vue?vue&type=template&id=0f88f66a&scoped=true"
import script from "./AppEmptyList.vue?vue&type=script&lang=js"
export * from "./AppEmptyList.vue?vue&type=script&lang=js"

import "./AppEmptyList.vue?vue&type=style&index=0&id=0f88f66a&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-0f88f66a"

export default script